import { defineWebView, getExpirationTime, refreshAuthToken } from '@camelot/webview-utils'
import { useAppStore } from '~/stores/appstore'

// eslint-disable-next-line unused-imports/no-unused-vars
export default defineNuxtPlugin((nuxtApp) => {
  function initWebView(): void {
    defineWebView({
      setToken: (token: string): void => {
        if (token) {
          const expirationTime = getExpirationTime(token)
          if (expirationTime) {
            const tokenValidityInMs = (expirationTime * 1000) - Date.now()
            console.warn(`New token expires in ${tokenValidityInMs / 1000} seconds`)
            if (tokenValidityInMs < 20000) {
              refreshAuthToken(window)
            }
            else {
              setTimeout(() => refreshAuthToken(window), tokenValidityInMs - 20000)
            }
            if (tokenValidityInMs < 0) {
              console.log('App injected an expired token, waiting for a new one')
            }
          }
        }
        localStorage.setItem('kcToken', token)
        const appStore = useAppStore()
        appStore.accessToken = token
      },
    })
  }

  return {
    provide: {
      initDeviceWebview: initWebView,
    },
  }
},
)
